import React from 'react';
import ReactDOM from 'react-dom';
import { TextField, ThemeProvider } from '@mui/material';

export function renderComputedField(field, cell, theme) {
  const container = document.createElement('div');
  const ComputedInputField = () => {
    const capacityPerHour = cell.get('customAttributes/capacityPerHour') || 0;
    const parallelism = cell.get('customAttributes/parallelism') || 1;
    const computedValue = Math.round((3600 / capacityPerHour) * parallelism);

    return (
      <ThemeProvider theme={theme}>
        <TextField
          fullWidth
          size="small"
          label={field.label}
          variant="outlined"
          value={computedValue}
          disabled
          InputProps={{
            readOnly: true,
            inputProps: {
              'data-cy': field.attributes?.['data-cy'],
            },
          }}
        />
      </ThemeProvider>
    );
  };
  ReactDOM.render(<ComputedInputField />, container);
  return container;
}
